export const ADVERTISE_STATUS = {
  'READY': '결제대기',
  'PAID': '결제완료',
  'RUNNING': '광고 진행 중',
  'REJECTED': '광고 거절',
  'FAIL': '결제 실패',
  'FINISH': '광고 완료',
  'REFUNDED': '환불 완료',
  'REQUEST_REFUND': '환불 신청'
}